import styled from '@emotion/styled';
import { LabelMedium, LightSmall, LightXSmall } from '../text/Typography';
import { RowChildrenContainer, RowContent, RowWrapper } from './CommonRowStyles';

interface ICommonRowProps {
    title: string;
    titleId?: string;
    titleSubtext?: string;
    description?: string;
    prefixComponent?: React.ReactNode;
    children?: React.ReactNode;
    tagNode?: React.ReactNode;
    wrap?: boolean;
    thin?: boolean;
}
/**
 * Non-interactive row component for displaying a title and description.
 * If you need an interactive row, consider using the ActionRow and SubActionRow components.
 */

export default function CommonRow({
    title,
    titleId,
    description,
    prefixComponent,
    children,
    titleSubtext,
    wrap = false,
    thin = false,
    ...restProps
}: ICommonRowProps) {
    return (
        <StyledRowWrapper $wrap={wrap}>
            <Row $wrap={wrap} $thin={thin} {...restProps}>
                {prefixComponent}
                <StyledRowContent>
                    <StyledLabelMedium id={titleId}>
                        {title}
                        {titleSubtext && <LightSmall as="span">{titleSubtext}</LightSmall>}
                    </StyledLabelMedium>

                    {description && <LightXSmall>{description}</LightXSmall>}
                </StyledRowContent>
                {children && <RowChildrenContainer $wrap={wrap}>{children}</RowChildrenContainer>}
            </Row>
        </StyledRowWrapper>
    );
}

const Row = styled.div<{ $wrap?: boolean; $thin?: boolean }>`
    display: flex;
    flex-wrap: ${(props) => (props.$wrap ? 'wrap' : 'nowrap')};
    align-items: ${(props) => (props.$thin ? 'center' : 'flex-start')};

    padding: ${(props) => (props.$thin ? '0 0.75rem' : '0.75rem')};
    gap: 1rem;
    flex-basis: 100%;
`;

const StyledRowContent = styled(RowContent)`
    justify-content: space-between;
`;

const StyledLabelMedium = styled(LabelMedium)`
    color: ${({ theme }) => theme.color.text};
`;

const StyledRowWrapper = styled(RowWrapper)<{ $wrap?: boolean }>`
    flex-wrap: ${(props) => (props.$wrap ? 'wrap' : 'nowrap')};
    border-bottom: none;
`;
